<template>
  <div class="pt-list_component">
    <a-list :loading="loading" itemLayout="vertical"  :data-source="dataList" :pagination="showPage && (total != 0) ?pagination:null" >
      <a-list-item slot="renderItem" slot-scope="item, index">
        <slot :item="item" :index="index"></slot>
      </a-list-item>
    </a-list>
  </div>

</template>

<script lang="jsx">
export default {
  name: 'PtList',
  props:{
    dataList:{
      type:Array,
      default:()=>{return []}
    },
    current:{
      type:Number,
      default:1,
    },
    loading:{
      type:Boolean,
      default:false
    },
    showPage:{
      type:Boolean,
      default:true,
    },

    total:{
      type:Number,
      default:0,
    },
    size:{
      type:Number,
      default:10,
    },
  },
  data(){
    let _this = this;
    return {
      pagination: {
        onChange: (page,pageSize) => {
          _this.$emit('onChange',page,pageSize)
        },
        onShowSizeChange: (current, pageSize) => {
          _this.$emit('onChange',current,pageSize)
        },
        showTotal:(total)=>{
          return `总计:  ${total} 条`
        },
        itemRender(current, type, originalElement) {
          if (type === 'prev') {
            return <a style="padding-right:10px">上一页</a>;
          } else if (type === 'next') {
            return <a  style="padding-left:10px;margin-right:10px">下一页</a>;
          }
          return originalElement;
        },
        pageSize: _this.size,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showSizeChanger:true,
        current:1,
        total:0,
        size:'small'
      },
    }
  },
  watch:{
    current(newVal){
      this.pagination.current = newVal;
    },
    total(newVal){
      this.pagination.total = newVal;
      console.log(newVal+"=========")
    },
    size(newVal){
      this.pagination.pageSize = newVal;
      console.log(newVal+"=========")
    }
  },
  methods:{

  }
}
</script>

<style scoped lang="less">
.pt-list_component{
  /deep/ .ant-list-item {
    border-bottom: none;
  }
}
</style>